import useThemeConfig from "src/themes/useThemeConfig";
import React from "react";

export default function AnnouncementMessage(props) {
  const config = useThemeConfig();
  const ThemedAnnouncementMessage = config.components.AnnouncementMessage;

  return <ThemedAnnouncementMessage {...props} />;
}
